module.exports = __webpack_public_path__ + "static/media/Pittsburgh_Penguins.fd449162.svg";